export function getFormatFunction(format) {

    switch (format){
        case "colorful":
            return formatOneSetColorful
        case "colorless":
            return formatOneSetColorless
        case "multi":
            return formatMultiSet
        default:
            return formatOneSetColorful
    }
}

export function formatOneSetColorful (data) {

    let colorSet = [
        'rgba(0, 40, 0, 0.2)',
        'rgb(7, 129, 130, 0.2)',
        'rgb(34, 139, 34, 0.2)',
        'rgba(75, 192, 192, 0.2)',
        'rgba(153, 102, 255, 0.2)',
        'rgba(255, 159, 64, 0.2)',
        'rgba(0, 200, 0, 0.2)',
        'rgba(200, 0, 0, 0.2)',
        'rgba(0, 0, 200, 0.2)',
    ]

    let borderSet = [
        'rgba(0, 40, 0, 1)',
        'rgba(7, 129, 130, 1)',
        'rgba(34, 139, 34, 1)',
        'rgba(75, 192, 192, 1)',
        'rgba(153, 102, 255, 1)',
        'rgba(255, 159, 64, 1)',
        'rgba(0, 200, 0, 1)',
        'rgba(200, 0, 0, 1)',
        'rgba(0, 0, 200, 1)',
    ]

    let colorsAvailable = 9;

    let label = [];
    let amount = [];
    let colors = [];
    let border = [];


    console.log(data)

    for(let i = 0; i < data.length; i++){
        console.log(data[i]);
        console.log(data[i].label);
        label[i] = data[i].label
    }
    for(let i = 0; i < data.length; i++){
        amount[i] = data[i].amount
    }

    for(let i = 0; i < data.length; i++){
        colors[i] = colorSet[i % colorsAvailable]
        border[i] = borderSet[i % colorsAvailable]
    }

    console.log(label)
    console.log(amount)

    return {
        labels: label,
        datasets: [{
            label: "data",
            data: amount,
            backgroundColor: colors,
            borderColor: border,
            borderWidth: 1
        }]
    }
}

export function formatOneSetColorless (data) {

    let label = []
    let amount = []
    let colors = []
    let border = []
    for(let i = 0; i < data.length; i++){
        label[i] = data[i].label
    }
    for(let i = 0; i < data.length; i++){
        amount[i] = data[i].amount
    }
    for(let i = 0; i < data.length; i++){
        colors[i] = 'rgba(0, 40, 0, 0.2)'
        border[i] = 'rgba(0, 40, 0, 1)'
    }

    return {
        labels: label,
        datasets: [{
            data: amount,
            backgroundColor: colors,
            borderColor: border,
            borderWidth: 1
        }]
    }

}

export function formatMultiSet (data) {


    let label = []
    let amount = [
        [],[],[],[],[],[]
    ]

    let backgroundColors = [
        'rgba(255, 99, 132, 0.2)',
        'rgba(54, 162, 235, 0.2)',
        'rgba(255, 206, 86, 0.2)',
        'rgba(75, 192, 192, 0.2)',
        'rgba(153, 102, 255, 0.2)',
        'rgba(255, 159, 64, 0.2)',

    ]
    let backgroundColor = []
    for(let i = 0; i < 6; i++){
        backgroundColor[i] = backgroundColors.slice()
        backgroundColors.push(backgroundColors.shift())
    }

    let borderColors = [
        'rgba(255, 99, 132, 1)',
        'rgba(54, 162, 235, 1)',
        'rgba(255, 206, 86, 1)',
        'rgba(75, 192, 192, 1)',
        'rgba(153, 102, 255, 1)',
        'rgba(255, 159, 64, 1)',

    ];
    let borderColor = []
    for(let i = 0; i < 6; i++){
        borderColor[i] = borderColors.slice()
        borderColors.push(borderColors.shift())
    }

    for(let i = 0; i < data[0].length; i++){
        label[i] = data[0][i].label
    }

    for(let i = 0; i < data[0].length; i++){
        amount[0][i] = data[0][i].amount
        amount[1][i] = data[1][i].amount
    }

    return {
        labels: label,
        datasets: [{
            label: "Total Utilization",
            data: amount[0],
            backgroundColor: 'rgba(255, 99, 132, 0.1)',
            pointBackgroundColor: 'rgba(255, 99, 132, 0.1)',
            borderColor: 'rgba(255, 99, 132, 1)',
            pointBorderColor: 'rgba(255, 99, 132, 1)',
            borderWidth: 1
        },
            {
                label: "Utilization",
                data: amount[1],
                backgroundColor: 'rgba(255, 206, 86, 0.1)',
                pointBackgroundColor: 'rgba(255, 206, 86, 0.1)',
                borderColor: 'rgba(255, 206, 86, 1)',
                pointBorderColor: 'rgba(255, 206, 86, 1)',
                borderWidth: 1
            }
        ]
    }
}